import React from "react";

import PropTypes from "prop-types";
import ReactLoading from "react-loading";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";



const styles = (theme) => ({
  card: {
    width: "100%",
  },
  cardSelected: {
    border: "1px solid #4CAF50",
  },
  kisanSelected: {
    border: "1px solid #4287f5",
  },
  title: {
    fontSize: 20,
  },
  subheader: {
    fontSize: 14,
  },
  subTitle: {},
  subTitleRight: {
    float: "right",
  },
  media: {
    height: 0,
    paddingTop: "0%", // 16:9
  },
  actions: {
    display: "flex",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatarError: {
    backgroundColor: "#b0252d",
    height: 75,
    width: 75,
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  avatarOk: {
    backgroundColor: "#4caf50",
    height: 75,
    width: 75,
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  avatarBlue: {
    backgroundColor: "#4287f5",
    height: 75,
    width: 75,
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  cardContent: {
    backgroundColor: "#4CAF50",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitleBlack: {
    color: "#000000",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "200",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
  },
});

/*
* Site selector only displays if there is more than one site at a location.
*/

class SiteSelection extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      sites: null,
      selected: null,
      isLoading: true,
      anchorEl: null
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getSites();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  getSites = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    // Fetch data from api
    fetch
      .get(`${BASE_URL}/api/site/${this.props.locationId}`) // /api/site/:locationId  ${this.props.dataUrl}
      .then((response) => {
        const sites = response.data;

        // get index of site with corresponding SITE_ID from passed prop
        let selected; 
        sites.map((site, index) => {
          if(site.SITE_ID === this.props.selectedSite){
            selected = index;
          }
        });
        
        if (this._isMounted === true) {
          this.setState({
            sites: sites,
            selected: selected, //selected MUST be a number for dropdown to function properly
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleSiteChange = (event) => {
    this.handleMenuClose();
    const {sites} = this.state; 

    this.setState({ selected: event.target.value }, () => {
      // pass selected site object's SITE_ID back to parent based on selected array index number
      this.props.handleSiteChange(sites[this.state.selected].SITE_ID);
    });
  };

  handleMenuClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }
  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  }

  render() {
    const { sites, selected, anchorEl } = this.state;

    return (
      <div>
        {selected == null ? (
          <ReactLoading
            type="spin"
            color="#000000"
            style={{
              width: "20%",
              margin: "auto",
            }}
          />
        ) : (sites.length > 1 && (
          <div>
            <Typography variant="subtitle1" gutterBottom p={5}>
              Site: {" "}
            
              <Button aria-controls="simple-menu" aria-haspopup="true" variant="outlined" onClick={this.handleMenuClick}>
                {sites[selected].SITE_NAME}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={this.handleMenuClose}
              > 
                {
                  sites.map((site, index) => {
                    return (
                      <MenuItem key={site.SITE_ID} onClick={this.handleSiteChange} value={index}>{site.SITE_NAME}</MenuItem>
                    )
                  })
                }
              </Menu>
            </Typography>
          </div>
       ) )}
      </div>
    );
  }
}

SiteSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  locationId: PropTypes.number.isRequired,
  handleSiteChange: PropTypes.func.isRequired,
  selectedSite: PropTypes.number.isRequired,
};

export default withStyles(styles)(SiteSelection);



// WEBPACK FOOTER //
// ./src/components/Terminal/SiteSelection.jsx